import { React, useEffect, useState } from 'react';
import aboutbanner from '../images/about/about_banner.png'
import mobaboutbanner from '../images/about/about_banner.png'
import section1 from '../images/about/section-1.png'
import section2 from '../images/about/work_location.png'
import overview1 from '../images/about/company-overview_1.png'
import overview2 from '../images/about/company-overview_2.png'
import overview3 from '../images/about/company-overview_3.png'
import edge from '../images/about/15years_bg.png'
// import crocs from '../images/about/client_logo/crocs.png'
import minibanner from '../images/about/banner-bg.png'
import Banner from '../Components/Banner';
// import Button from "../Utils/Button";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Form from '../Components/Form';
import Chatwithus from '../Components/chatwithus';
import Whyus from '../Card-Components/Whyus'
import FormModal from "../Components/FormModal";

import client_logo_1 from "../images/about/client_logo/5kcar.png"
import client_logo_2 from "../images/about/client_logo/tata.png"
import client_logo_3 from "../images/about/client_logo/saatva.png"
import client_logo_4 from "../images/about/client_logo/amazon.png"
import client_logo_5 from "../images/about/client_logo/hdfc.png"
import client_logo_6 from "../images/about/client_logo/hyundai.png"
import client_logo_7 from "../images/about/client_logo/indian_terrain.png"
import client_logo_8 from "../images/about/client_logo/crocs.png"
import client_logo_9 from "../images/about/client_logo/grand_world.png"
import client_logo_10 from "../images/about/client_logo/reliance.png"
import client_logo_11 from "../images/about/client_logo/green_trends.png"
import client_logo_12 from "../images/about/client_logo/stanza_living.png"
import client_logo_13 from "../images/about/client_logo/lenskart.png"
import client_logo_14 from "../images/about/client_logo/zolo.png"
import client_logo_15 from "../images/about/client_logo/srivari.png"
import client_logo_16 from "../images/about/client_logo/specsmakers.png"
import client_logo_17 from "../images/about/client_logo/kgtown.png"
import client_logo_18 from "../images/about/client_logo/saatva_1.png"
import client_logo_19 from "../images/about/client_logo/vascon.png"
import male_avatar from '../images/about/Male_avatar.png'
import female_avatar from '../images/about/female_avatar.png'
import linkedin_icon from '../images/about/Linkedin_icon.png'
import Button from '../Components/Button';





const Clients = [
    {
        src: client_logo_1,
        alt: "Client_logo"
    },
    {
        src: client_logo_2,
        alt: "Client_logo"
    },
    {
        src: client_logo_3,
        alt: "Client_logo"
    },
    {
        src: client_logo_4,
        alt: "Client_logo"
    },
    {
        src: client_logo_5,
        alt: "Client_logo"
    },
    {
        src: client_logo_6,
        alt: "Client_logo"
    },
    {
        src: client_logo_7,
        alt: "Client_logo"
    },
    {
        src: client_logo_8,
        alt: "Client_logo"
    },
    {
        src: client_logo_9,
        alt: "Client_logo"
    },
    {
        src: client_logo_10,
        alt: "Client_logo"
    },
    {
        src: client_logo_11,
        alt: "Client_logo"
    },
    {
        src: client_logo_12,
        alt: "Client_logo"
    },
    {
        src: client_logo_13,
        alt: "Client_logo"
    },
    {
        src: client_logo_14,
        alt: "Client_logo"
    },
    {
        src: client_logo_15,
        alt: "Client_logo"
    },
    {
        src: client_logo_16,
        alt: "Client_logo"
    },
    {
        src: client_logo_17,
        alt: "Client_logo"
    },
    {
        src: client_logo_18,
        alt: "Client_logo"
    },
    {
        src: client_logo_19,
        alt: "Client_logo"
    },

]





function About() {


    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>


            <Banner
                img={aboutbanner}
                mimg={mobaboutbanner}
                alt={"banner_image"}
                heading={"Future focused, client centered."}
                subheading={"Expertise that's unmatched across Tamil Nadu."}
                button={"Explore Properties"}
                textposition={"w-[85%] bottom-8 left-8 right-8 lg:w-[675px] lg:bottom-[100px] lg:left-[100px]"}
                renderButton={() => (
                    <Button name={"Explore Properties"} design= {"filled"} action={"internal-linking"} pageLink={"/residential"} />
                )}
            />


            {/* First Section */}
            <div className="my-9 py-9 max-w-7xl mx-auto font-alibaba px-6 sm:px-0" data-aos="fade-up">

                <div className="flex flex-col items-center gap-y-[70px]">

                    <div className='max-w-[950px] mx-auto'>
                        <h1 className='heading'>Insight, Trust & Experience  <br className='hidden md:block' /> You Can Count On.</h1>
                        <hr className='border-yellow border-[2px] w-[87px] mx-auto my-5 sm:my-[35px]' />
                        <p className="service-description max-w-[800px] mx-auto px-5 xl:px-0" data-aos="fade-up" data-aos-duration="1100">Lands & Lands is a future-focused real estate investment, development and services company built on traditional values of service integrity, market expertise and last-mile access., we make every step seamless — from first conversation to final handover.</p>
                    </div>

                    <img className="w-[828px] sm:h-[478px] object-cover" src={section1} alt="section-1" data-aos="fade-up" />

                </div>

                <div className="flex flex-col mt-20 items-center sm:mt-[130px] gap-y-[60px]" data-aos="fade-up">
                    <div className='max-w-[770px] mx-auto'>
                        <h1 className='heading'>The places we serve</h1>
                        <hr className='border-yellow border-[2px] w-[87px] mx-auto my-5 sm:my-[35px]' />
                        <p className="service-description max-w-[730px] mx-auto" data-aos="fade-up" data-aos-duration="1100">Lands and Lands remains proudly committed to serving our original markets-Coimbatore City and the whole of Western Tamil Nadu and Chennai. But we’re growing, too, bringing expertise all across the state of Tamil Nadu.</p>
                    </div>

                    <img className="sm:w-[527px] sm:h-[524px] md:w-[450px] md:h-[450px] lg:w-[527px] lg:h-[524px]  mt-14 lg:mt-0" src={section2} alt="section-2" data-aos="fade-up" />
                </div>

            </div>

            {/*15 years of edge Section */}

            <div className="bg-[#1A1A1A] w-full py-20 sm:py-[100px] px-6 lg:px-0" data-aos="fade-up">

                <div className="max-w-[943px] mx-auto">
                    <img className="w-[268px] mx-auto" src={edge} alt="years_of_edge" data-aos="fade-up" />

                    <div className="mx-auto mt-[43px] flex flex-col items-center">
                        <p className="font-alibaba text-white text-[16px] leading-[[24px] sm:text-[22px] sm:leading-[34px] text-center mb-[70px]" data-aos="fade-up" data-aos-duration="700">For over 15 years, Lands and Lands has been the most comprehensive and trusted service provider across residential, commercial, industrial and liaison services for Individuals, Organizations, Government and Industry all across Tamilnadu.</p>
                        
                        
                    </div>
                </div>
            </div>



            {/* Company Overview Prithiv */}

            <div className="max-w-[1267px] mx-auto my-24 sm:my-[130px] font-alibaba  px-6">
                <h1 className='heading'>Company overview</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto mt-[25px]' />

                <div className="max-w-[1175px] mx-auto mt-[100px] grid sm:grid-cols-3 gap-y-20" data-aos="fade-up">

                    <div className='w-[211px] mx-auto'>
                        <img className="w-[55px] mx-auto" src={overview1} alt="overview1" data-aos="fade-up" />

                        <div className='flex flex-col items-center mt-[50px]' data-aos="fade-up">
                            <h2 className="font-noto text-[50px] font-bold">15+</h2>
                            <p className='font-alibaba text-[20px] text-[#5F5D5E] mt-[10px]'>Years of edge</p>
                        </div>
                    </div>
                    <div className='w-[211px] mx-auto'>
                        <img className="w-[55px] mx-auto" src={overview2} alt="overview2" data-aos="fade-up" />

                        <div className='flex flex-col items-center mt-[50px]' data-aos="fade-up">
                            <h2 className="font-noto text-[50px] font-bold">500+</h2>
                            <p className='font-alibaba text-[20px] text-[#5F5D5E] mt-[10px]'>Project Completed</p>
                        </div>
                    </div>
                    <div className='w-[211px] mx-auto'>
                        <img className="w-[55px] mx-auto" src={overview3} alt="overview3" data-aos="fade-up" />

                        <div className='flex flex-col items-center mt-[50px]' data-aos="fade-up">
                            <h2 className="font-noto text-[50px] font-bold">50+</h2>
                            <p className='font-alibaba text-[20px] text-[#5F5D5E] mt-[10px]'>Expert team members</p>
                        </div>
                    </div>


                </div>

            </div>


            {/* Why us */}
            <Whyus />

            {/*Our Clients */}

            <div className="max-w-[1196px] mx-auto my-[120px] px-6">
                <h1 className='heading !font-noto'>Our Clients</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' />

                <div className="grid grid-cols-4 gap-x-[35px] gap-y-[60px] mt-[60px] sm:grid-cols-7" >

                    {Clients.map((items) => {

                        return (
                            <img className="w-auto h-auto my-auto filter grayscale" src={items.src} alt={items.alt} data-aos="fade-up" data-aos-duration="800" data-aos-anchor-placement="bottom-bottom" />
                        )
                    })}

                </div>
            </div>

            <Chatwithus />

            
        </>
    )
}


export default About;